const mixinSelectRemote = {
  data() {
    const {
      disabled,
      label
    } = this.column
    return {
      options: [],
      loading: false,
      disabled: !!disabled,
      placeholder: `请选择${label}`
    }
  },
  mounted() {
    if (this.column.dicOption === '2') {
      this.apiPost('')
    }
  },
  methods: {
    remoteMethod(query) {
      if (query.trim() !== '') {
        this.loading = true
        this.apiPost(query)
      } else {
        this.loading = true
        this.apiPost('')
      }
    },
    apiPost(query) {
      const {
        dicUrl,
        dicMethod
      } = this.column
      this.$http({
        method: dicMethod,
        url: dicUrl.indexOf('?') >= 0 ? `${dicUrl}&searchKeyword=${query}` : `${dicUrl}?searchKeyword=${query}`
      }).then(res => {
        this.loading = false
        if (res.data.length) {
          this.options = res.data
        } else {
          this.options = []
        }
        this.column.dicData = this.options
      }).catch(error => {
        this.$message.error(error.msg)
      })
    },
    handleChange(e) {
      this.casUrl()
      // this.customEvent(e)
    },
    casUrl() {
      const {
        casUrl
      } = this.column

      if (!casUrl) {
        return false
      }

      let bodyData = this.viewFormData.modelData
      bodyData['taskDefinitionKey'] = this.viewFormData.taskDefinitionKey
      this.$http
        .post(`${casUrl}`, bodyData)
        .then((response) => {
          let columnList = response.data.columnList
          let modifyData = {}
          columnList.forEach((item) => {
            if (item.hasOwnProperty('value')) {
              modifyData[item.prop] = item.value // 记录修改的value值
            }
            this.setCasUrlValue(this.viewFormData.options.column, item, this)
            if (this.viewFormData.options.group) {
              this.viewFormData.options.group.forEach(groupItem => {
                this.setCasUrlValue(groupItem.column, item, this)
              })
            }
            // if (item.hasOwnProperty('value')) {
            // // if (item.value) {
            //   modifyData[item.prop] = item.value // 记录修改的value值
            // }
            // this.viewFormData.options.column
            //   .filter((columnItem) => columnItem.prop === item.prop)
            //   .forEach((columnItem) => {
            //     Object.keys(item).forEach((itemKey) => {
            //       this.$set(columnItem, itemKey, item[itemKey]) // 循环修改字段属性
            //     })
            //     // Object.assign(columnItem, item)// 循环修改字段属性
            //   })
          })
          // 统一修改数据
          Object.keys(modifyData).forEach(itemKey => {
            if (Array.isArray(modifyData[itemKey])) {
              this.viewFormData.modelData[itemKey] = []
              modifyData[itemKey].forEach(subItem => this.viewFormData.modelData[itemKey].push(this.deepClone(subItem)))
            } else {
              this.$set(this.viewFormData.modelData, itemKey, modifyData[itemKey])
            }
          })
        })
        .catch((error) => {
          this.$message.error(error.msg || error.message)
        })
    },
    setCasUrlValue(column, item, that) {
      column
        .filter((columnItem) => columnItem.prop === item.prop)
        .forEach((columnItem) => {
          Object.keys(item).forEach((itemKey) => {
            let remoteList = ['select']
            if (itemKey === 'value' &&
          columnItem.remote && columnItem.display && remoteList.indexOf(columnItem.type) >= 0) {
              columnItem.display = !columnItem.display
              setTimeout(() => {
                columnItem.display = !columnItem.display
              }, 0)
            }
            that.$set(columnItem, itemKey, item[itemKey]) // 循环修改字段属性
          })
        // Object.assign(columnItem, item)// 循环修改字段属性
        })
    },
    customEvent(e) {
      const {
        customEvent,
        customEventName
      } = this.column
      if (customEvent) {
        window.workFlow[customEventName].bind(
          this,
          e,
          this.viewFormData.options.column,
          this.viewFormData.modelData,
          this.viewFormData
        )()
      }
    }
  }
}

export default mixinSelectRemote
